export default {
  add_items: 'Artikelen toevoegen',
  remove_items: 'Artikelen verwijderen',
  place_order: 'Bestelling plaatsen',
  proceed_to_payment: 'Doorgaan naar betaling',
  go_to_menu: 'Naar het menu',

  toasts: {
    input_errors_found: 'Er zijn enkele problemen met je bestelgegevens',
  },

  error_messages: {
    internal_error: {
      title: 'Bestelling mislukt 😔',
      description: 'Helaas was er een onverwacht probleem met je bestelling, ons techteam werkt er al aan 🛠️.',
    },
  },
};
